import { useEffect, useRef, useState } from "react";
import ImageGallery from "../ImageGallery/ImageGallery";
import Breadcrumb from "../breadcrumb/breadcrumb";
import SEO from "../SEO/SEO";
import { trackPhoneClick, trackAirbnbClick } from "../../utils/analytics";
import "./studio516.css";

// Import de toutes les images
import img1 from "../../assets/img516/8980022986927334899.avif";
import img2 from "../../assets/img516/7050975502778288398.avif";
import img3 from "../../assets/img516/20230308_084409.avif";
import img4 from "../../assets/img516/20230308_084414.avif";
import img5 from "../../assets/img516/20241031_121019[1].avif";
import img6 from "../../assets/img516/20230308_084352.avif";
import img7 from "../../assets/img516/20230308_084338.avif";

export default function Studio516() {
  const airbnbRef = useRef(null);
  const [isAirbnbVisible, setIsAirbnbVisible] = useState(false);

  const images = [
    { src: img1, alt: "Studio 516 - Vue 1" },
    { src: img2, alt: "Studio 516 - Vue 2" },
    { src: img3, alt: "Studio 516 - Vue 3" },
    { src: img4, alt: "Studio 516 - Vue 4" },
    { src: img5, alt: "Studio 516 - Vue 5" },
    { src: img6, alt: "Studio 516 - Vue 6" },
    { src: img7, alt: "Studio 516 - Vue 7" },
  ];

  useEffect(() => {
    // Lazy loading du widget Airbnb - charge seulement quand visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isAirbnbVisible) {
            setIsAirbnbVisible(true);
          }
        });
      },
      { rootMargin: "100px" }, // Charge 100px avant que l'élément soit visible
    );

    const currentRef = airbnbRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isAirbnbVisible]);

  useEffect(() => {
    // Charger le script Airbnb seulement si visible
    if (isAirbnbVisible && airbnbRef.current) {
      const script = document.createElement("script");
      script.src = "https://www.airbnb.fr/embeddable/airbnb_jssdk";
      script.async = true;
      airbnbRef.current.appendChild(script);
    }
  }, [isAirbnbVisible]);
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Apartment",
    name: "Studio 516 - Location Cure Thermale",
    description:
      "Studio de 19m² classé 2 étoiles, idéal pour cure thermale à Châtel-Guyon, à 2 pas des Thermes Aïga",
    floorSize: {
      "@type": "QuantitativeValue",
      value: 19,
      unitCode: "MTK",
    },
    numberOfRooms: 1,
    occupancy: {
      "@type": "QuantitativeValue",
      minValue: 1,
      maxValue: 2,
    },
    starRating: {
      "@type": "Rating",
      ratingValue: "2",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "3 Place Brosson",
      addressLocality: "Châtel-Guyon",
      postalCode: "63140",
      addressCountry: "FR",
    },
    offers: {
      "@type": "Offer",
      price: "540",
      priceCurrency: "EUR",
      description: "Tarif pour 3 semaines de cure thermale",
      availability: "https://schema.org/InStock",
    },
    amenityFeature: [
      { "@type": "LocationFeatureSpecification", name: "Cuisine équipée" },
      { "@type": "LocationFeatureSpecification", name: "Wifi" },
      { "@type": "LocationFeatureSpecification", name: "Ascenseur" },
      { "@type": "LocationFeatureSpecification", name: "Chauffage" },
    ],
  };

  return (
    <main>
      <SEO
        title="Studio 516 - Location Cure Thermale Châtel-Guyon | 2 Étoiles 19m²"
        description="Studio 2 étoiles de 19m² à Châtel-Guyon, idéal pour cure thermale. À 3min des Thermes Aïga. Équipé, fonctionnel. Dès 540€ les 3 semaines. ☎ 06 95 39 85 19"
        canonical="https://chatel-guyon-hotel-cure-thermes.fr/studio-516-2-etoiles-chatel-guyon"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <h1 className="visually-hidden">
        Studio 516 - Location Cure Thermale Châtel-Guyon
      </h1>
      <Breadcrumb
        items={[{ label: "Accueil", url: "/" }, { label: "Studio 516" }]}
      />
      <div id="std-container">
        <div className="stdleft">
          <div
            id="carousel516"
            role="region"
            aria-label="Galerie d'images du Studio 516"
          >
            <ImageGallery images={images} />
          </div>
        </div>
        <div className="stdright">
          <iframe
            src="https://www.bookingmood.com/airbnb-embed?language=fr-FR&listing=570220157395426750&theme=Elegant"
            className="iframe-calendar"
            title="Calendrier des disponibilités Studio 516"
          ></iframe>
          <hr className="section-divider-small" />
          <h2 className="centertext">
            Réservation au{" "}
            <a
              href="tel:+33695398519"
              onClick={() => trackPhoneClick("studio_page")}
            >
              06 95 39 85 19
            </a>
          </h2>
          <hr className="section-divider-top-only" />
          <div className="pricing-options516">
            <h3>Nos formules :</h3>
            <ul>
              <li>Trois semaines de 480.00€ à 600.00€ (Cure)</li>
              <li>Semaine de 200.00€ à 250.00€</li>
              <li>Week-end de 90.00€ à 105.00€ à week end 3 nuits</li>
              <li>Taxe de séjour 0.60€ (Prix par nuitée/personne)</li>
            </ul>
            <h3>Nos options :</h3>
            <ul>
              <li>
                Supplément animaux journalier à 3.00€ (Forfait : 20 euros la
                cure)
              </li>
              <li>Ménage de fin de cure 50.00€</li>
              <li>Linge de toilette 15.00€</li>
              <li>Linge de lit 15.00€</li>
            </ul>
          </div>
        </div>
      </div>
      <hr className="section-divider" />
      <div className="box-stack">
        <div className="box-info">
          <p>
            Découvrez notre studio de 19m², classé deux étoiles, situé au
            cinquième étage avec ascenseur, parfait pour une personne seule ou
            un couple. Compact mais très fonctionnel, il dispose de tout le
            nécessaire pour un séjour agréable: coin cuisine équipé, salle de
            bain moderne, espace nuit confortable.
            <br />
            Il permet de profiter de tous les avantages du centre-ville de
            Châtel-Guyon, à deux pas des Thermes, des restaurants et des
            animations.
            <br />
            Merci de signaler la présence d'animaux lors de la réservation.
          </p>
        </div>
        <hr className="section-divider-small" />
        <h2 className="centertext">Equipements</h2>
        <div className="box-info">
          <div className="equipment">
            <div className="centerequipment">
              <h3>Chambre et linge</h3>
              <ul>
                <li>Étendoir à linge</li>
                <li>Équipements de base (Serviettes et draps)</li>
                <li>Cintres</li>
                <li>Oreillers et couvertures supplémentaires</li>
                <li>Fer à repasser</li>
                <li>Espace de rangement pour les vêtements</li>
              </ul>
            </div>

            <div className="centerequipment">
              <h3>Salle de bain</h3>
              <ul>
                <li>Sèche-cheveux</li>
                <li>Douche équipée de jets massants</li>
              </ul>
            </div>

            <div className="centerequipment">
              <h3>Cuisine et salle à manger</h3>
              <ul>
                <li>Réfrigérateur</li>
                <li>Congélateur</li>
                <li>Vaisselle et couverts</li>
                <li>Plaques de cuisson</li>
                <li>Four</li>
                <li>Bouilloire électrique</li>
                <li>Micro-ondes</li>
                <li>Grille-pain</li>
                <li>Cafetière</li>
              </ul>
            </div>

            <div className="centerequipment">
              <h3>Autres</h3>
              <ul>
                <li>Chauffage électrique</li>
                <li>Wifi</li>
                <li>Ascenseur</li>
                <li>Parking public à proximité</li>
                <li>Dépôt de bagages autorisé</li>
                <li>Clés remises par l'hôte</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="box-info"></div>
      </div>
      <hr className="section-divider" />
      <h2 className="centertext">Disponible également sur Airbnb</h2>
      <div
        className="airbnb-embed-frame airbnb-embed-container"
        data-id="570220157395426750"
        data-view="home"
        data-hide-price="true"
        ref={airbnbRef}
        title="Studio 516 sur Airbnb"
      >
        <a
          href="https://www.airbnb.fr/rooms/570220157395426750?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
          onClick={() => trackAirbnbClick("studio516")}
        >
          Voir sur Airbnb
        </a>
        <a
          href="https://www.airbnb.fr/rooms/570220157395426750?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget"
          rel="nofollow"
          onClick={() => trackAirbnbClick("studio516")}
        >
          Appartement en résidence · Châtel-Guyon · ★4,88 · 1 chambre · 1 lit ·
          1&nbsp;salle de bain
        </a>
      </div>
    </main>
  );
}
